import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01ec7e58"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-cancel" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!

  return (_openBlock(), _createBlock(_component_ion_chip, {
    color: "danger",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_label, { color: "danger" }, {
        default: _withCtx(() => [
          _createElementVNode("span", null, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ]),
          _hoisted_1
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}